import enTranslation from "./translated/english.json";
import frTranslation from "./translated/french.json";
import deTranslation from "./translated/german.json";
import itTranslation from "./translated/italian.json";
import haTranslation from "./translated/hausa.json";
import igTranslation from "./translated/igbo.json";
import ptTranslation from "./translated/portuguese.json";
import esTranslation from "./translated/spanish.json";
import yoTranslation from "./translated/yoruba.json";
import nlTranslation from "./translated/dutch.json";
import msTranslation from "./translated/malay.json";
import cmnTranslation from "./translated/mandarin chinese.json";
import taTranslation from "./translated/tamil.json";
import hiTranslation from "./translated/hindi.json";
import bnTranslation from "./translated/bengali.json";
import mrTranslation from "./translated/marathi.json";
import teTranslation from "./translated/telugu.json";
import guTranslation from "./translated/gujarati.json";
import urTranslation from "./translated/urdu.json";
import knTranslation from "./translated/kannada.json";
import orTranslation from "./translated/odia.json";
import mlTranslation from "./translated/malayalam.json";
import idTranslation from "./translated/indonesian.json";
import jvTranslation from "./translated/javanese.json";
import suTranslation from "./translated/sundanese.json";
import gnTranslation from "./translated/guarani.json";
import swTranslation from "./translated/swahili.json";
import zuTranslation from "./translated/zulu.json";
import xhTranslation from "./translated/xhosa.json";
import afTranslation from "./translated/afrikaans.json";
import viTranslation from "./translated/vietnamese.json";
import zh_cn_Translation from "./translated/chinese.json";
import kmTranslation from "./translated/khmer.json";
import thTranslation from "./translated/thai.json";
import loTranslation from "./translated/lao.json";

export default function translationsResources () {
return {
    "en": { "translation": enTranslation },
    "fr": { "translation": frTranslation },
    "de": { "translation": deTranslation },
    "it": { "translation": itTranslation },
    "ha": { "translation": haTranslation },
    "ig": { "translation": igTranslation },
    "pt-PT": { "translation": ptTranslation },
    "es": { "translation": esTranslation },
    "yo": { "translation": yoTranslation },
    "ms": { "translation": msTranslation },
    "cmn": { "translation": cmnTranslation },
    "ta": { "translation": taTranslation },
    "hi": { "translation": hiTranslation },
    "bn": { "translation": bnTranslation },
    "mr": { "translation": mrTranslation },
    "te": { "translation": teTranslation },
    "gu": { "translation": guTranslation },
    "ur": { "translation": urTranslation },
    "kn": { "translation": knTranslation },
    "or": { "translation": orTranslation },
    "ml": { "translation": mlTranslation },
    "id": { "translation": idTranslation },
    "jv": { "translation": jvTranslation },
    "su": { "translation": suTranslation },
    "gn": { "translation": gnTranslation },
    "sw": { "translation": swTranslation },
    "zu": { "translation": zuTranslation },
    "xh": { "translation": xhTranslation },
    "af": { "translation": afTranslation },
    "vi": { "translation": viTranslation },
    "zh-CN": { "translation": zh_cn_Translation },
    "km": { "translation": kmTranslation },
    "th": { "translation": thTranslation },
    "lo": { "translation": loTranslation },
    "nl": { "translation": nlTranslation }
  }
}